import InlineAudioPlayer from './InlineAudioPlayer';

export default class InlineAudioPlayers {
	constructor() {
		this.players = new Map();

		document.addEventListener('bless', ({ detail }) => {
			this.container = detail.next.container;
			this.init();
		});

		document.addEventListener('audioplayerplaying', e => {
			this.players.forEach(player => {
				player.pause();
			});
		});
	}

	init() {
		// Destroy previous players
		if (this.players) {
			this.players.forEach(player => {
				player.destroy();
			});

			this.players = new Map();
		}

		const inlinePlayers = this.container.querySelectorAll('[data-inline-audio]');

		inlinePlayers.forEach(player => {
			const playerInstance = new InlineAudioPlayer(player);

			playerInstance.init();

			playerInstance.on('play', inlineAudioPlayer => {
				this.players.forEach((instance, instanceEl) => {
					if (inlineAudioPlayer.el !== instanceEl) {
						instance.pause();
					}
				});
			});

			this.players.set(player, playerInstance);
		});
	}
}
